import useCountUp from 'hooks/useCountUp';
import { countText, formatReminderEuros } from './invoiceRemindersText';

const SummaryCard = ({ label, value }) => (
  <div className="flex-1 min-w-[200px] rounded-lg border border-gray-200 bg-white px-4 py-3">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="mt-1 text-xl font-medium text-gray-900">{value}</div>
  </div>
);

/**
 * The three cards above the reminders (JBWEB-1283, mockup 7.1): "À faire"
 * (invoices), "En retard" (what they owe) and "Contentieux" (count and
 * amount). A dash until the summary is read.
 */
const RemindersSummaryCards = ({ summary, text }) => {
  const unknown = text('cards.unknown');
  const litigation = summary?.litigation;
  const shownToDo = useCountUp(summary ? (summary.toDo ?? 0) : null);
  const shownLateAmount = useCountUp(summary ? summary.lateAmount : null);
  const shownLitigationCount = useCountUp(
    litigation ? (litigation.count ?? 0) : null,
  );
  const shownLitigationAmount = useCountUp(
    litigation ? litigation.amount : null,
  );

  return (
    <div className="flex flex-wrap gap-3" data-testid="reminders-summary">
      <SummaryCard
        label={text('cards.toDo')}
        value={
          summary
            ? countText(text, 'cards.invoices', Math.round(shownToDo))
            : unknown
        }
      />
      <SummaryCard
        label={text('cards.late')}
        value={summary ? formatReminderEuros(shownLateAmount) : unknown}
      />
      <SummaryCard
        label={text('cards.litigation')}
        value={
          litigation
            ? text('cards.litigationValue', {
                count: Math.round(shownLitigationCount),
                amount: formatReminderEuros(shownLitigationAmount),
              })
            : unknown
        }
      />
    </div>
  );
};

export default RemindersSummaryCards;
